<template>
    <div class="column is-one-third">
        <table class="table is-fullwidth">
            <tr>
                <th>Costs:</th>
                <td><input v-model="cost" class="input" type="number" :disabled="isLocked"></td>
            </tr>
            <tr>
                <th>Sales:</th>
                <td><input v-model="sale" class="input" type="number" :disabled="isLocked"></td>
            </tr>
            <tr>
                <th>Profit:</th>
                <td><input v-model="profit" class="input" type="number" :disabled="isLocked"></td>
            </tr>
        </table>
    </div>
</template>

<script>
    export default {
        props:['car'],
        data () {
            return {

            }
        },
        computed: {
            isLocked() {
                return this.$store.getters.getProformaInvoiceLockedStatus
            },
            cost: {
                get() {
                    return this.$store.getters.getProformaInvoice.cost
                },
                set(value) {
                    this.$store.dispatch('changeProformaInvoiceFieldValue', { field: 'cost', value: value })
                }
            },
            sale: {
                get() {
                    return this.$store.getters.getProformaInvoice.sale
                },
                set(value) {
                    this.$store.dispatch('changeProformaInvoiceFieldValue', { field: 'sale', value: value })
                }
            },
            profit: {
                get() {
                    return this.$store.getters.getProformaInvoice.profit
                },
                set(value) {
                    this.$store.dispatch('changeProformaInvoiceFieldValue', { field: 'profit', value: value })
                }
            }
        }
    }
</script>

<style scoped>
    td {
        font-size: large;
    }
    th {
        font-size: small;
    }
</style>



// WEBPACK FOOTER //
// src/components/Cars/Columns/ProformaInvoice/ProformaInvoiceTotal.vue